(() => {
  'use strict';
  const editable = target => target instanceof Element && Boolean(
    target.closest('input, textarea, select, [contenteditable]:not([contenteditable="false"])')
  );
  document.addEventListener('contextmenu', event => {
    if (!editable(event.target)) event.preventDefault();
  });
  document.addEventListener('selectstart', event => {
    if (!editable(event.target)) event.preventDefault();
  });
})();
